'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ListItem(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['icon', 'children', 'className']);

  var classes = (0, _classnames2.default)('list__item', className);

  return _react2.default.createElement(
    'li',
    _extends({ className: classes }, props),
    icon && _react2.default.createElement(_icon2.default, { name: icon, size: '8', className: 'list__icon' }),
    _react2.default.createElement(
      'span',
      { className: 'list__content' },
      children
    )
  );
}

ListItem.propTypes = {
  icon: _propTypes2.default.node,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

exports.default = ListItem;